import { useTranslation } from "react-i18next";
import MainLayout from "../../../layouts/layout";
import "../cs.scss";
import "./index.scss";
import { Breadcrumb, Button, Col, Form, Input, Row, Select, Steps } from "antd";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import ReactInputMask from "react-input-mask";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import OTP from "../../../auxiliary/otp-modal/otp";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { clearFormData } from "../../../../reducer/serviceReducer";
import { useDispatch, useSelector } from "react-redux";
import { validateInput } from "../../../../tools/tools";
import { CheckTokenWithOTP, setTokenOTP } from "../../../../tools/services";

const CSValidMsisdn = () => {
	const [t] = useTranslation("global");
	const [frmValid] = Form.useForm();
	const { queryOTPIsRequired, queryCertType } = useAPIPublic();
	const { isValidMSISDNToSimSwap } = useDealer();

	const [isOpenOtp, setIsOpenOtp] = useState(false);
	const [smsMobile, setSmsMobile] = useState();
	const [isProgress, setIsProgress] = useState(false);

	const [certType, setCertType] = useState([]);

	const [changeCertNoLabel, setChangeCertNoLabel] = useState(false);

	const formData = useSelector((state) => state);
	const dispatch = useDispatch();
	const nav = useNavigate();

	useEffect(() => {
		const initialCallService = async () => {
			let response = await queryCertType();
			if (response) {
				setCertType(response);
			}
		};
		initialCallService();
	}, []);

	const handleSubmit = async () => {
		dispatch(clearFormData(["swchange"]));
		setIsProgress(true);
		try {
			let valid = await frmValid.validateFields();
			if (valid) {
				let payloadValid = {
					certtype: valid.certtype,
					msisdn: valid.msisdn.toString().replace(/ /g, ""),
					certno: valid.certno,
				};
				let responseValid = await isValidMSISDNToSimSwap(payloadValid);
				if (responseValid && !responseValid.HasError) {
					let payload = {
						msisdn: valid.msisdn.toString().replace(/ /g, ""),
						certno: valid.certno,
						certtype: valid.certtype,
					};
					let resValid = await queryOTPIsRequired(payload);
					if (resValid) {
						if (resValid.otpIsRequired) {
							setSmsMobile(valid.smsmobile.toString().replace(/ /g, ""));
							setIsOpenOtp(true);
						} else {
							nav(_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.ValidKit, {
								state: {
									msisdn: payload.msisdn,
									certno: payload.certno,
									certtype: valid.certtype,
								},
							});
						}
					}
				}
			}
		} catch (error) {
			console.error(error);
		}
		setIsProgress(false);
	};
	const handleCallBackOtp = async (token) => {
		setIsOpenOtp(false);
		if (token) {
			await setTokenOTP({ expireUTCTime: token.expireUTCTime, token: token.token });
			const isTokenOTP = await CheckTokenWithOTP();

			if (isTokenOTP) {
				nav(_adr.Root + _adr.SimCardReplacement.Index + _adr.SimCardReplacement.Replacement + _adr.SimCardReplacement.ValidKit, {
					state: {
						token: token?.token,
						msisdn: frmValid.getFieldValue("msisdn").toString().replace(/ /g, ""),
						certno: frmValid.getFieldValue("certno"),
						certtype: frmValid.getFieldValue("certtype"),
					},
				});
			}
		}
	};
	const handleChangeValueCertType = (value) => {
		value === 0 ? setChangeCertNoLabel(false) : setChangeCertNoLabel(true);
	};
	return (
		<>
			<div className="container-main container-cs">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardreplacement.validPage.title") }]}
					/>
					<div className="title-page">
						<h3>{t("simcardreplacement.validPage.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main cs-container">
						<div className="g-format-page">
							<div className="g-body-format-page">
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={0}
											items={[
												{
													title: "احراز هویت",
												},
												{
													title: "مشخصات سیم‌کارت",
												},
												{
													title: "پیش فاکتور",
												},
												{
													title: "فرم تعویض سیم‌کارت",
												},
											]}
										/>
									</div>
								</div>
								<div className="holder-valid">
									<p>شماره موبایل آپتلی خود و شماره موبایل ثبت شده (درصورت وجود) با کدملی را وارد نمایید</p>
									<Row>
										<Col span={8} xl={8} lg={12} md={15} xs={24} sm={24}>
											<div className="holder-form">
												<Form form={frmValid} layout="vertical">
													<Form.Item
														className="input-normal"
														name="certtype"
														rules={[validateInput({ t: t, validate: true })]}
														label="نوع مدرک شناسایی">
														<Select onChange={handleChangeValueCertType}>
															{certType.map((item, key) => (
																<Select.Option key={key} value={item.value}>
																	{item.name}
																</Select.Option>
															))}
														</Select>
													</Form.Item>

													<Form.Item
														className="input-normal"
														name="msisdn"
														label="شماره همراه آپتل"
														rules={[
															validateInput({
																t: t,
																validate: true,
																type: "msisdnOrg",
															}),
														]}>
														<div>
															<ReactInputMask autoComplete="off" inputMode="numeric" className="msisdn-mask" dir="ltr" mask="0\9\9\99 99 99 99" />
														</div>
													</Form.Item>
													<Form.Item
														className="input-normal"
														name="certno"
														label={changeCertNoLabel ? "کدشناسایی" : "کدملی"}
														rules={[
															validateInput({
																t: t,
																validate: true,
																// type: "number",
																// length: 10,
															}),
														]}>
														<Input dir="ltr" autoComplete="off" inputMode="numeric" />
													</Form.Item>
													<Form.Item
														className="input-normal"
														name="smsmobile"
														label="شماره موبایل"
														rules={[
															validateInput({
																t: t,
																validate: true,
																type: "msisdnOrg",
															}),
														]}
														hasFeedback>
														<div>
															<ReactInputMask autoComplete="off" inputMode="numeric" className="msisdn-mask" dir="ltr" mask="0\999 999 99 99" />
														</div>
													</Form.Item>
												</Form>
											</div>
										</Col>
									</Row>
								</div>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button className="btn-normal btn-aptel" htmlType="submit" onClick={handleSubmit} type="primary" disabled={isProgress} danger>
										{isProgress ? t("form.inProgress") : <>مرحله بعد</>}
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</div>

			<OTP
				planid={process.env.REACT_APP_PLANID_CHARGE_WALLET_CS}
				isOpen={isOpenOtp}
				certno={frmValid.getFieldValue("certno")}
				expiretimebyminute={process.env.REACT_APP_LOGIN_EXPIRE}
				msisdn={smsMobile?.slice(1)}
				sessionid={Date.now()}
				callback={handleCallBackOtp}
				certtype={frmValid.getFieldValue("certtype")}
				checkmsisdnvcertno={true}
			/>
		</>
	);
};
export default CSValidMsisdn;
